module.exports = __webpack_public_path__ + "img/Endangered_Animals_turtle.68acdacc.png";